import { Routes } from '@angular/router';
import { FailedComponent } from './failed/failed.component';
import { SearchComponent } from './search/search.component';
import { ProfileComponent } from './profile/profile.component';
import { TrackingComponent } from './tracking/tracking.component';
import { EventsComponent } from './events/events.component';
import { EventComponent } from './event/event.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [MsalGuard]
    },
    {
        path: '',
        component: SearchComponent,
        canActivate: [MsalGuard] 
    },
    {
        path: 'login-failed',
        component: FailedComponent
    },
    {
        path:'private/Tracking/LastEvent',
        component: TrackingComponent,
        canActivate: [MsalGuard] 
    },
    {
        path:'private/Tracking/Event/:EventId',
        component: TrackingComponent,
        canActivate: [MsalGuard] 
    },
    {
        path:'private/Tracking/Events/Producers-Consumers',
        component: EventsComponent,
        canActivate: [MsalGuard] 
    },
    {
        path:'private/Tracking/UpsertEvent/:Id',
        component: EventComponent,
        canActivate: [MsalGuard] 
    }
];